import { render, staticRenderFns } from "./AppendFileIcon.vue?vue&type=template&id=6b0d2816&"
import script from "./AppendFileIcon.vue?vue&type=script&lang=js&"
export * from "./AppendFileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports